var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"payment-home-page pa-0",attrs:{"fluid":""}},[(!_vm.$vuetify.breakpoint.xsOnly)?_c('div',{staticClass:"payment-chart-section mb-4"},[_c('PaymentMethodLine')],1):_vm._e(),_c('List')],1)}
var staticRenderFns = []

export { render, staticRenderFns }